import { Box, Theme, Typography } from "@mui/material";
import { NO_DATA_AVAILABLE } from "../../../utils/constant";

export function ZeroStateInvestment({ isSuccess }: { isSuccess?: boolean }): JSX.Element {
    return (
        <Box
            sx={(theme: Theme) => ({
                backgroundColor: theme.palette.grey[50],
                borderRadius: "15px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%"
            })}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    rowGap: "5px"
                }}
            >
                <Box
                    component="img"
                    src="/images/zero-state-investment.svg"
                    alt="Zero State"
                    width={165}
                    height={165}
                    sx={{ objectFit: "contain" }}
                />
                <Typography
                    variant="body_600"
                    sx={(theme: Theme) => ({
                        fontWeight: 500,
                        lineHeight: "22.5px",
                        letterSpacing: "0.01px",
                        color: theme.palette.text.primary,
                        textAlign: {xs:"center"}
                    })}
                >
                    {isSuccess ? `You don't have any investments.` : NO_DATA_AVAILABLE}
                </Typography>
            </Box>

        </Box>
    )
}